var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBed2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer_1",
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m27 9.2675781h-14.5c-.1089478 0-.2089233.0298462-.3070679.0620117-.7121582-.6531982-1.6524658-1.0620117-2.6929321-1.0620117-2.2060547 0-4 1.7944336-4 4 0 .7317505.211853 1.4092407.5563354 2h-2.0563354v-8.7675781c0-.5522461-.4472656-1-1-1s-1 .4477539-1 1v21c0 .5522461.4472656 1 1 1s1-.4477539 1-1v-1.4418945h24v1.4418945c0 .5522461.4472656 1 1 1s1-.4477539 1-1v-14.2324219c0-1.6542969-1.3457031-3-3-3zm1 3v4.7905273h-14.5v-5.7905273h13.5c.5517578 0 1 .4487305 1 1zm-20.5 0c0-1.1030273.8974609-2 2-2s2 .8969727 2 2-.8974609 2-2 2-2-.8969726-2-2zm-3.5 10.7905274v-6.7905273h7.5v1.7905273c0 .5522461.4472656 1 1 1h15.5v4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed2);
export default __webpack_public_path__ + "static/media/bed_2.2ba2a28b3d3b39b38f623964a9b56830.svg";
export { ForwardRef as ReactComponent };